const RemoveTurkishChars = ({ text }) => {
  const removeTurkishChars = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };
  return removeTurkishChars(text).toLowerCase().replace(/\s+/g, '-').trim();
};

export default RemoveTurkishChars;